<template>
  <bm-tooltip v-model="showTooltip" top>
    <template #activator="{ on, attrs }">
      <v-icon
        color="text02"
        class="mx-1"
        icon
        small
        v-bind="attrs"
        v-on="on"
        @click="showTooltip = !showTooltip"
      >
        construction
      </v-icon>
    </template>
    <span>{{ $m.beta_icon_tooltip }}</span>
  </bm-tooltip>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import BmTooltip from "@/components/controls/input/BmTooltip.vue";

export default defineComponent({
  name: "BetaIcon",
  components: { BmTooltip },
  setup(props, context) {
    return {
      showTooltip: ref(false),
    };
  },
});
</script>
